<template>
  <b-modal
    id="items-form-modal"
    size="xl"
    :title="`Create new item (Category: ${categoryName})`"
    hide-footer
    scrollable
    @shown="modalShownHandler"
    @hidden="modalHiddenHandler"
  >
    <b-row>
      <b-col
        md="6"
        style="border-right:1px solid lightgray"
      >
        <b-form
          novalidate
          @submit.prevent="submitForm"
        >
          <validation-observer ref="formRef">
            <b-row>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Name En"
                  rules="required"
                >
                  <b-form-group
                    label="Name En*"
                    label-for="item-name-en"
                  >
                    <b-form-input
                      id="item-name-en"
                      v-model="formData.name.en"
                      placeholder="Name En"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Name Ar"
                  rules="required"
                >
                  <b-form-group
                    label="Name Ar*"
                    label-for="item-name-ar"
                  >
                    <b-form-input
                      id="item-name-ar"
                      v-model="formData.name.ar"
                      placeholder="Name Ar"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Price"
                  rules="required"
                >
                  <b-form-group
                    label="Price*"
                    label-for="item-price"
                  >
                    <b-form-input
                      id="item-price"
                      v-model="formData.price"
                      placeholder="Price"
                      type="number"
                      :disabled="priceOnSelectionToggle"
                    />
                    <span class="text-danger">
                      {{ errors[0] || priceValidation }}
                    </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <b-form-group label="Price on selection">
                  <b-form-checkbox
                    v-model="priceOnSelectionToggle"
                    switch
                    @input="priceOnSelectionToggleInput"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Description En"
                  label-for="description-en"
                >
                  <b-form-textarea
                    id="description-en"
                    v-model="formData.description.en"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Description Ar"
                  label-for="description-ar"
                >
                  <b-form-textarea
                    id="description-ar"
                    v-model="formData.description.ar"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Allergy Note En"
                  label-for="allergy-en"
                >
                  <b-form-textarea
                    id="allergy-en"
                    v-model="formData.allergyNote.en"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Allergy Note Ar"
                  label-for="allergy-ar"
                >
                  <b-form-textarea
                    id="allergy-ar"
                    v-model="formData.allergyNote.ar"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Image">
                  <upload-item-image
                    :item-image-url="formData.imageUrl"
                    @image-uploaded="formData.imageKey = $event"
                    @image-deleted="formData.imageKey = undefined"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                class="pt-4"
              >
                <b-button
                  block
                  variant="primary"
                  type="submit"
                  :disabled="submitting"
                >
                  <b-spinner
                    v-if="submitting"
                    small
                  />
                  <span v-else>{{ item ? 'Edit': 'Save' }} item</span>
                </b-button>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-col>
      <b-col md="6">
        <card-collapse title="Custom Hours">
          <b-row
            v-for="(hour, ix) in formData.availability.hours"
            :key="hour.day + ix"
          >
            <b-col md="3">
              <span>{{ hour.day }}</span>
            </b-col>
            <b-col md="2">
              <b-form-checkbox
                v-model="hour.available"
                switch
              />
            </b-col>
            <b-col
              md="7"
              class="p-0 d-flex align-items-center"
            >
              <b-form-timepicker
                v-model="hour.from"
                :disabled="!hour.available"
              />
              <span class="mx-1">To</span>
              <b-form-timepicker
                v-model="hour.to"
                :disabled="!hour.available"
              />
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="9">
              Only sell this item on specific dates
            </b-col>
            <b-col md="3">
              <b-form-checkbox
                v-model="formData.availability.specifcDates.available"
                switch
              />
            </b-col>
            <b-col md="6">
              <b-form-group label="Start Selling">
                <b-form-datepicker
                  v-model="formData.availability.specifcDates.from"
                  :disabled="!formData.availability.specifcDates.available"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="End Selling">
                <b-form-datepicker
                  v-model="formData.availability.specifcDates.to"
                  :disabled="!formData.availability.specifcDates.available"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <span class="text-danger">
                {{ validateStartEndSelling }}
              </span>
            </b-col>
          </b-row>
        </card-collapse>
        <card-collapse title="Modifier Groups">
          <b-spinner
            v-if="fetchingGroups"
            variant="primary"
          />
          <span v-if="modifierGroups.length == 0 && !fetchingGroups">No modifier groups for this business</span>
          <div
            v-for="g in modifierGroups"
            :key="g.id"
          >
            <b-form-checkbox
              :checked="!!formData.selectionGroups.find(s => s.id == g.id)"
              @input="selectionGroupsInput($event, g)"
            >
              {{ g.name.en }}
            </b-form-checkbox>
            <small>{{
              g.selections
                .map(
                  (el) =>
                    el.name.en + `( ${el.price ? `JOD ${el.price}` : "free"} )`
                )
                .toString()
            }}</small>
            <hr>
          </div>
        </card-collapse>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import {
  BForm,
  BFormInput,
  BFormGroup,
  BModal,
  BFormTimepicker,
  BFormTextarea,
  BFormDatepicker,
  BButton,
  BSpinner,
  BRow,
  BCol,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import UploadItemImage from './UploadItemImage.vue'
import CardCollapse from '@/UI/CardCollapse.vue'

export default {
  components: {
    BModal,
    BForm,
    CardCollapse,
    BFormDatepicker,
    BButton,
    BSpinner,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    BFormGroup,
    BFormTimepicker,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    UploadItemImage,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const generateItemCopyHandler = () => {
      const temp = {
        imageKey: undefined,
        selectionGroups: [],
        price: 0,
        allergyNote: {
          en: '',
          ar: '',
        },
        description: {
          en: '',
          ar: '',
        },
        name: {
          en: '',
          ar: '',
        },
        categoryId: '',
        availability: {
          specifcDates: {
            from: null,
            to: null,
            available: true,
          },
          hours: [
            {
              day: 'Saturday',
              available: true,
              from: '09:00',
              to: '17:00',
            },
            {
              day: 'Sunday',
              available: true,
              from: '09:00',
              to: '17:00',
            },
            {
              day: 'Monday',
              available: true,
              from: '09:00',
              to: '17:00',
            },
            {
              day: 'Tuesday',
              available: true,
              from: '09:00',
              to: '17:00',
            },
            {
              day: 'Wednesday',
              available: true,
              from: '09:00',
              to: '17:00',
            },
            {
              day: 'Thursday',
              available: true,
              from: '09:00',
              to: '17:00',
            },
            {
              day: 'Friday',
              available: true,
              from: '09:00',
              to: '17:00',
            },
          ],
        },
      }

      return JSON.parse(JSON.stringify(temp))
    }
    const categoryName = computed(() => props.category?.name?.en)
    const businessId = ctx.root.$route.params.id
    const priceOnSelectionToggle = ref(false)

    const formData = ref(generateItemCopyHandler())

    const modifierGroups = ref([])
    const fetchingGroups = ref(false)
    const getModifierGroups = async () => {
      modifierGroups.value = []
      fetchingGroups.value = true
      const res = await ctx.root.$store.dispatch(
        'business/getBusinessSelectionGroups',
        {
          businessId,
        },
      )
      const { data } = res.data.data
      modifierGroups.value = data
      fetchingGroups.value = false
    }
    const selectionGroupsInput = (evModel, group) => {
      if (evModel) {
        formData.value.selectionGroups.push(group)
      } else {
        const ix = formData.value.selectionGroups.findIndex(
          el => el.id === group.id,
        )
        formData.value.selectionGroups.splice(ix, 1)
      }
    }

    const priceOnSelectionToggleInput = ev => {
      if (ev) {
        formData.value.price = 0
      }
    }

    const priceValidation = computed(() => {
      if (formData.value.price <= 0) {
        if (priceOnSelectionToggle.value) {
          if (formData.value.selectionGroups.length === 0) {
            return 'At least one modifier group is required'
          }
          let selectionsHasPrice = false
          // eslint-disable-next-line no-restricted-syntax
          for (const group of formData.value.selectionGroups) {
            if (selectionsHasPrice) break
            // eslint-disable-next-line no-restricted-syntax
            for (const selection of group.selections) {
              if (+selection.price !== 0) {
                selectionsHasPrice = true
                break
              }
            }
          }
          if (!selectionsHasPrice) { return 'At least one selection must have a price' }
          return ''
        }

        return 'Price cannot be zero'
      }
      return ''
    })
    const validateStartEndSelling = computed(() => {
      if (formData.value.availability.specifcDates.available) {
        if (
          formData.value.availability.specifcDates.from
          && formData.value.availability.specifcDates.to
        ) {
          if (
            new Date(formData.value.availability.specifcDates.from).getTime()
            > new Date(formData.value.availability.specifcDates.to).getTime()
          ) {
            return 'End Time cannot be before Start Time'
          }
        }
      }
      return ''
    })

    const submitting = ref(false)
    const submitForm = async () => {
      if (priceValidation.value !== '') return
      if (validateStartEndSelling.value !== '') return
      const validatationResult = await ctx.refs.formRef.validate()
      if (!validatationResult) return
      const PAYLOAD = JSON.parse(JSON.stringify(formData.value))
      PAYLOAD.selectionGroups = PAYLOAD.selectionGroups.map((g, ix) => ({
        id: g.id,
        order: ix + 1,
      }))
      PAYLOAD.price = +PAYLOAD.price
      PAYLOAD.categoryId = props.category.id
      PAYLOAD.businessId = businessId
      if (formData.value.availability.specifcDates.from && formData.value.availability.specifcDates.to) {
        const from = new Date(formData.value.availability.specifcDates.from)
        // from.setHours(0, 0, 0, 0)
        const to = new Date(formData.value.availability.specifcDates.to)
        // to.setHours(0, 0, 0, 0)
        PAYLOAD.availability.specifcDates.from = from
        PAYLOAD.availability.specifcDates.to = to
      }
      try {
        submitting.value = true
        if (props.item) {
          await ctx.root.$store.dispatch('business/updateItem', {
            payload: PAYLOAD,
            itemId: props.item.id,
          })
          await ctx.root.$store.dispatch('business/transitionItem', {
            item: {
              ...PAYLOAD,
              requestedChange: {},
            },
            body: {
              action: 'APPROVE',
            },
          })
        } else {
          const res = await ctx.root.$store.dispatch('business/createItem', PAYLOAD)
          await ctx.root.$store.dispatch('business/transitionItem', {
            item: res.data.data.data,
            body: {
              action: 'APPROVE',
            },
          })
        }
        ctx.root.$bvModal.hide('items-form-modal')
        ctx.emit('done')
      } finally {
        submitting.value = false
      }
    }
    const modalShownHandler = () => {
      getModifierGroups()
      if (props.item) {
        formData.value = JSON.parse(JSON.stringify(props.item))
        priceOnSelectionToggle.value = +formData.value.price === 0
      }
    }

    const modalHiddenHandler = () => {
      priceOnSelectionToggle.value = false
      formData.value = generateItemCopyHandler()
      ctx.emit('hidden')
    }

    return {
      submitForm,
      selectionGroupsInput,
      fetchingGroups,
      getModifierGroups,
      submitting,
      validateStartEndSelling,
      modalShownHandler,
      priceOnSelectionToggleInput,
      modifierGroups,
      categoryName,
      priceValidation,
      required,
      priceOnSelectionToggle,
      modalHiddenHandler,
      formData,
    }
  },
}
</script>

<style></style>
